import { render } from "./arrows-horizontal.vue?vue&type=template&id=1a63c466"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/arrows-horizontal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a63c466"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a63c466', __exports__)) {
    api.reload('1a63c466', __exports__)
  }
  
  module.hot.accept("./arrows-horizontal.vue?vue&type=template&id=1a63c466", () => {
    api.rerender('1a63c466', render)
  })

}


export default __exports__